<template>
  <div class="ti">
    <div>
      <div style="margin-bottom:1px">
        <el-date-picker size="mini"
                        v-model="datevalue"
                        type="daterange"
                        unlink-panels
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
        </el-date-picker>
        <el-select size="mini" v-model="pid" filterable placeholder="请选项目" class="kuan">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>

        <el-select size="mini" v-model="value2" filterable placeholder="搜索选择" class="kuan">
          <el-option
            v-for="item in options1"
            :key="item.id"
            :label="item.label"
            :value="item.id">
          </el-option>
        </el-select>

        <el-select size="mini" v-model="chargeitemID" filterable placeholder="费用类型" class="kuan">
          <el-option
            key=""
            label="全部费用"
            value="">
          </el-option>
          <el-option
            v-for="item in chargeitem"
            :key="item.id"
            :label="item.chargeItem_name"
            :value="item.id">
          </el-option>
        </el-select>

        <el-input size="mini" class="search" placeholder="请输入搜索内容" v-model="search" clearable></el-input>
        <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
        <el-button size="mini" type="primary text2" @click="xiugai" v-if="checked.checked0 || checked.checked1 || checked.checked2 || checked.checked3 || checked.checked4 || checked.checked5 || checked.checked6 || checked.checked7 || checked.checked8 || checked.checked9 || checked.checked10 || checked.checked11 " >核销</el-button>
        <!-- <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="excelPost">导出</el-button> -->
      </div>

      <div>
        <p>操作备注：</p>
        <p>
          1、清除缴费订单本质是清除订单未付款的订单，对已经付款完成的订单不受影响。<i class="el-icon-delete-solid" style="color: #F56C6C"></i>
        </p>
        <p>
          2、点击以下<i class="el-icon-delete-solid" style="color: #F56C6C"></i>按钮，即可完成对应的清除。
        </p>
        <p>
          3、“组编号”是按批次生成的订单组编号，一经删除就会删除该批次的所有账单记录，所以会提示操作人员是否进行删除该组编号；
        </p>
        <p>
          4、“编号”只是对该条信息进行删除处理，不会提醒，只有结果。
        </p>
      </div>

      <v-divider></v-divider>
      <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              <el-popover
                placement="bottom"
                trigger="hover"
                v-model="zuId_visible">
                <div style="margin-bottom: 5px">
                  <el-input size="mini" v-model="weiyi_group_id" :clearable="true" placeholder="请输入复制的id"></el-input>
                </div>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="zuId_visible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="delWeiyiGroupId();zuId_visible = false">确定</el-button>
                </div>
                <div size="mini" slot="reference">组编号 <i title="删除主编号的所有信息" class="el-icon-delete-solid" style="color: #F56C6C"></i></div>
              </el-popover>

            </th>
            <th class="text-left">编号</th>
            <th class="text-left">姓名</th>
            <th class="text-left">收费对象</th>
            <th class="text-left">费用名称</th>
            <th class="text-left">金额</th>
            <th class="text-left">状态</th>
            <th class="text-left">生成日期</th>
          </tr>
          </thead>
          <!-- 撤销 -->
          <tbody
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
          <tr class="text1" v-for="(item,index) in desserts" :key="item.id">
            <td>
              {{item.weiyi}}
              <i title="删除主编号的所有信息" class="el-icon-document-copy" style="color: #F56C6C" @click="copy(item.weiyi)"></i>
<!--              <el-tooltip v-if="index == 0" content="删除主编号的所有信息" placement="top">-->
<!--                <i title="删除主编号的所有信息" class="el-icon-delete-solid" style="color: #F56C6C" @click="orderDel('weiyi',item.weiyi)"></i>-->
<!--              </el-tooltip>-->
            </td>
            <td >
              {{item.number}}
              <el-tooltip content="删除本条信息" placement="top">
                <i title="删除本条信息" class="el-icon-delete-solid" style="color: #F56C6C" @click="orderDel('number',item.number)"></i>
              </el-tooltip>
            </td>
            <td >{{item.h_name}}<span v-if="!item.h_name">--</span></td>
            <td >
              {{item.h_name_date}}
            </td>
            <td ><span v-if="item.charge_name">{{item.charge_name}}</span><span v-else>{{item.xsc_ChargeName}}</span></td>
            <td >{{item.charge}}</td>
            <td ><span v-if="item.state==1">待支付</span><span v-if="item.state==2">已完成</span></td>
            <td >{{item.generate_date}}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change"  show-total />
      </div>
      <div class="zhanwu" v-else>没有数据</div>
    </div>
  </div>

</template>

<script>
import ERP from "../../../assets/lib/ERP";

export default {
  name: 'ClearOrder',
  data () {
    return {
      chargeitemID:'',
      chargeitem:[],
      chargePercentage:'',
      chargePercentage1:'',
      buttonSize:'1',
      checked:{
        checked0:'',
        checked1:'',
        checked2:'',
        checked3:'',
        checked4:'',
        checked5:'',
        checked6:'',
        checked7:'',
        checked8:'',
        checked9:'',
        checked10:'',
        checked11:'',
      },
      modal12:false,
      loading:false,
      reductions:false,
      datevalue:[],
      options: [
        {
          value: '',
          label: ''
        },],
      options1: [
        {
          id: 1,
          label: '编号'
        },
        {
          id: 2,
          label: '姓名'
        },
        {
          id: 3,
          label: '身份证'
        },
        {
          id: 4,
          label: '房产'
        },
      ],
      value: '',
      value1:'',
      value2:1,
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      chakana:[],
      state:1,
      order:{
        charge:0,
        chargePay:0,
        PaidChargeSum:0,
        discount:0,
        delaySum:0,
        delayDays:0,
        delayDiscount:0,
      },
      charge:0,
      price:0,
      charges:0,
      prices:0,
      priceCharge:0,
      itemOrder:[],
      homeName:'',
      pid:'',
      zuId_visible:false,
      weiyi_group_id:'',
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    this.$myhttp.get('admin/getorderList?login='+login,{
      'Content-Type': 'application/json'
    }).then(backdata=>{ // 异步执行成功后
      // this.value1 = backdata.data[0];//开启不查全部
      this.value = backdata.data;
      this.change(1)
    });
    //加载公司列表和归属列表
    //项目列表
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
    }).then(backdata=>{
      this.options = backdata.data.data;
    });
    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
    }).then(backdata=>{
      this.chargeitem = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //导出
    excelPost(){
      if(this.state != 1){
        this.$Message.error('点击待付款，选择费用类型导出');
        return false;
      }
      if(this.chargeitemID == ''){
        this.$Message.error('费用类型不能为空');
        return false;
      }
      this.$Loading.start();
      this.$myhttp.get('admin/getOrderExcel?id=1&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID,{
        'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        console.log(333);
        this.$Loading.finish();
      });
    },
    //减免（折扣）
    cdj_reduction(){
      var order = this.order;
      //收费金额
      var charge = this.price;
      //减免收费金额
      var discount = this.charge;
      //滞纳金额
      var delaySum = this.prices;
      //减免滞纳金额
      var delayDiscount = this.charges;
      var data = {
        id:order.id,
        charge:charge,
        discount:discount,
        delaySum:delaySum,
        delayDiscount:delayDiscount
      };
      var delaySum1 = Number(delaySum)+Number(delayDiscount);
      var charge1 = Number(charge)+Number(discount);
      if(delaySum1.toFixed(2) < Number(delayDiscount) || charge1.toFixed(2) < Number(discount)){
        this.$Message.error('金额不合法');
        return false;
      }
      this.$myhttp.post('admin/orderDiscount',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.searchs();
        this.$Message.success('操作成功!');
      });
      // console.log(data);
    },
    modals(e){
      if(this.state != e){
        this.state = e;
        this.change(1);
      }
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/clearOrderIndex?id='+ e + '&pid='+ this.pid + '&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID+"&homeName="+this.homeName+'&tm_limit='+this.datevalue.join(','),{
        'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.desserts = backdata.data[0];
        this.total = backdata.data[1];
        this.page = backdata.data[2];
        this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.change(1);
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该权限吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading=true;
        this.$myhttp.post('admin/listDelete',{id:e},{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data == 200){
            this.dela = true;
            this.change(1);
            this.$Message.success('删除成功!');
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 树组件点击触发
    orderDel(name,val) {
      console.log(name,val)
      var that=this;
      if(name==='weiyi'){
        this.$confirm('此操作将删除该编号此次的所有记录，谨慎操作, 是否继续?', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.clearOrder(name,val)
        })
      }else {
        that.clearOrder(name,val)
      }
    },

    clearOrder(name,val){
      var that=this;
      ERP.showLoading()
      that.$myhttp.post("admin/clearOrder",{name:name,val:val}).then(res=>{
        let data=res.data
        if(data&&data.code){
          ERP.hideLoading()
          setTimeout(function () {
            that.change(1)
          },500)
          that.$message.success('操作成功')
        }else {
          ERP.hideLoading()
          that.$message.success(data.msg||'操作失败')
        }
      }).catch(e=>{
        ERP.hideLoading()
      })
    },

    copy(data){
      ERP.copy(data,res=>{
        ERP.showToast({title:res})
      })
    },
    delWeiyiGroupId(){
      var that=this;
      if(that.weiyi_group_id){
        that.orderDel('weiyi',that.weiyi_group_id)
        that.weiyi_group_id='';
      }else {
        ERP.showToast({title:'输入组ID'})
      }
    }
  },
  watch:{
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/clearOrder.vue